import real from "./riaFundsReal.json";
import alloc from "./allocatorReal.json";
import { ER, INDEX_FEE, SHORT } from "./allocatorData";

/* RIA fund-portfolio mockups: real N-PORT holdings / active share / grades (riaFundsReal.json, allocatorReal.json);
   ERs approximate; client names, $ amounts, models and clients are SAMPLE. */

export const RF = real;
export const AL = alloc;
export const OBS_F = real.obs_date;
export { ER, INDEX_FEE, SHORT };
export const usd = (v) => {
  if (v >= 1e6) { const m = v / 1e6; return `$${m.toFixed(m < 10 ? 2 : m < 100 ? 1 : 0)}M`; }
  if (v >= 1e3) return `$${v < 1e4 ? (v / 1e3).toFixed(1) : Math.round(v / 1e3)}k`;
  return `$${Math.round(v)}`;
};
export const aer = (g) => (ER[g.fund] - (1 - g.active_share) * INDEX_FEE) / g.active_share;
export const isIndexLike = (g) => g.ungraded_reason === "index_like";

export const effN = (ov, L) => {
  const p = [];
  L.forEach((a, i) => L.slice(i + 1).forEach((b) => p.push(ov[a][b] / 100)));
  const rho = p.reduce((s, x) => s + x, 0) / p.length;
  return { rho, eff: L.length / (1 + (L.length - 1) * rho) };
};

export const MODELS = [
  { id: "agg", name: "Aggressive Growth", clients: 64, aum: 48e6, funds: { FBGRX: 0.3, TRBCX: 0.3, MFEGX: 0.4 } },
  { id: "core", name: "Core Equity", clients: 112, aum: 96e6, funds: { AGTHX: 0.35, FCNTX: 0.35, DODGX: 0.3 } },
  { id: "bal", name: "Balanced Core", clients: 88, aum: 71e6, funds: { VPMCX: 0.4, DODGX: 0.3, MFEGX: 0.3 } },
  { id: "val", name: "Value Tilt", clients: 36, aum: 22e6, funds: { DODGX: 0.5, OAKMX: 0.5 } },
];
export const SAMPLE_FLAGS = { OAKMX: { drift: true }, FBGRX: { turn: true } };
export const CANDS = ["PRBLX", "JENSX", "FMAGX", "PRGFX"];

export const fundChecks = (f) => {
  const g = AL.grades[f];
  const s = SAMPLE_FLAGS[f] || {};
  const checks = [
    ["Active share ≥ 80%", g.active_share >= 0.8],
    ["Grade ≥ C", g.letter ? !["D", "F"].includes(g.letter) : null],
    ["Crowded share < 12%", (g.crowded_share || 0) < 0.12],
    ["No style drift", !s.drift],
    ["Turnover normal", !s.turn],
  ];
  const fails = checks.filter((c) => c[1] === false).length;
  return { g, checks, fails, status: fails >= 2 ? "REPLACE" : fails === 1 ? "WATCH" : "KEEP" };
};
